export var AccountMenuPane;
(function (AccountMenuPane) {
    AccountMenuPane[AccountMenuPane["GeneralMenu"] = 0] = "GeneralMenu";
    AccountMenuPane[AccountMenuPane["SignIn"] = 1] = "SignIn";
    AccountMenuPane[AccountMenuPane["Register"] = 2] = "Register";
    AccountMenuPane[AccountMenuPane["ConfirmPassword"] = 3] = "ConfirmPassword";
})(AccountMenuPane || (AccountMenuPane = {}));
